import { useEffect } from 'react';
import { StoreProvider } from './redux/Store';
import './index.css';
import IdleTimerParent from './components/react-idle-timer/idle-timer-parent';
import LocalRouter from './routes';

const App = () => {
  // DOCS: hotfix for redirection to portal-qa
  useEffect(() => {
    const { hostname } = window.location;
    if (hostname === 'portal-react.fibe.in') {
      const oldUrl = window.location.href;
      const newUrl = oldUrl.replace('portal-react', 'portal-qa');
      window.location.href = newUrl;
    }
  }, []);

  return (
    <StoreProvider>
      <IdleTimerParent>
        <LocalRouter />
      </IdleTimerParent>
    </StoreProvider>
  );
};

export default App;
